import i18n from "../i18n";
import { API_LANG_MODE, DEFAULT_LANGUAGE } from "./constants";

export const getCurrentLanguage = () => i18n.language || DEFAULT_LANGUAGE;

export const getLanguageHeaders = () => ({
  "Accept-Language": getCurrentLanguage(),
});

/**
 * URL-ə ?lang= parametri əlavə edir (query/both rejimində).
 */
export const withLanguageQuery = (url) => {
  if (API_LANG_MODE !== "query" && API_LANG_MODE !== "both") {
    return url;
  }

  const lang = getCurrentLanguage();
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}lang=${encodeURIComponent(lang)}`;
};

/**
 * fetch() üçün dil header və query dəstəyi (axios interceptor ilə eyni məntiq).
 */
export const fetchWithLanguage = (url, init = {}) => {
  const headers = {
    Accept: "application/json",
    ...getLanguageHeaders(),
    ...init.headers,
  };

  return fetch(withLanguageQuery(url), { ...init, headers });
};

/**
 * Axios config-ə dil parametrlərini əlavə edir.
 * @param {import('axios').InternalAxiosRequestConfig} config
 */
export const applyLanguageToRequest = (config) => {
  const lang = getCurrentLanguage();
  const next = { ...config };
  next.headers = { ...next.headers, "Accept-Language": lang };

  if (API_LANG_MODE === "query" || API_LANG_MODE === "both") {
    next.params = { ...next.params, lang };
  }

  return next;
};

const normalizeCategoryKey = (value) =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ə/g, "e")
    .replace(/ı/g, "i")
    .replace(/ş/g, "s")
    .replace(/ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/ö/g, "o")
    .replace(/ü/g, "u")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const SERVICE_CATEGORY_I18N_KEYS = [
  { match: (key) => key.includes("ferdi") || key.includes("individual") || key.includes("sexs") },
  { match: (key) => key.includes("diaqnostik") || key.includes("diagnostic") },
  { match: (key) => key.includes("korporativ") || key.includes("corporate") },
];

/**
 * CMS-dən gələn kateqoriya adını cari dilə uyğun etiketə çevirir.
 * @param {string} categoryName
 * @param {(key: string, options?: object) => string} t
 */
export const translateServiceCategory = (categoryName, t) => {
  const normalized = normalizeCategoryKey(categoryName);
  if (!normalized) return categoryName;

  const rule = SERVICE_CATEGORY_I18N_KEYS.find(({ match }) => match(normalized));
  if (!rule) return categoryName;

  const keys = ["services.categories.individual", "services.categories.diagnostic", "services.categories.corporate"];
  const index = SERVICE_CATEGORY_I18N_KEYS.indexOf(rule);
  return t(keys[index], { defaultValue: categoryName });
};
